<template>
  <div id="app">
    <particles />
    <router-view />
  </div>
</template>
<script>
import particles from "./components/Particles.vue";

export default {
  components: {
    particles
  }
}
</script>

<style lang="sass">

#app
  font-family: 'Lemonada', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  // background: #ED213A
  // background: -webkit-linear-gradient(to right, #93291E, #ED213A)
  // background: linear-gradient(to right, #93291E, #ED213A)
  background: #f85032
  background: -webkit-linear-gradient(to right, #e73827, #f85032)
  background: linear-gradient(to right, #e73827, #f85032)
  position: relative
  width: 100vw
  height: 100vh

</style>
